import { CloseIcon } from '../../../../../../assets/icon/svg';
import { MessageIcon } from '../../../../../../assets/icon/iconify';
import { ChatAttachment } from './chat-attachment-modal';
import { GroupChat } from '../../../../../../api/gms/proposal-chat/proposal-chats-api-state';

interface Props {
    isSearchOpen: boolean;
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    setIsSearchOpen: (value: boolean) => void;
    setShowAttachments: (value: boolean) => void;
    allAttachments: ChatAttachment[];
    filteredMessages: GroupChat[];
}

export default function ChatsHeader({ isSearchOpen, searchTerm, setSearchTerm, setIsSearchOpen, setShowAttachments, allAttachments, filteredMessages }: Props) {
    return (
        <div className="shrink-0 border-b bg-gray-50">
            <div className="flex items-center gap-2 px-3 py-2.5">
                {isSearchOpen ? (
                    <div className="relative min-w-0 flex-1">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" >
                            <circle cx="11" cy="11" r="7" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="m20 20-4-4" />
                        </svg>
                        <input
                            autoFocus
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search messages..."
                            className="w-full rounded-md border border-gray-200 bg-white py-2 pl-8 pr-8 text-[10px] text-gray-700 placeholder:text-gray-400 focus:border-[#186cb2] focus:outline-none focus:ring-2 focus:ring-[#186cb2]/10"
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                onClick={() => setSearchTerm('')}
                                className="absolute right-2 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                                title="Clear search"
                            >
                                <CloseIcon />
                            </button>
                        )}
                    </div>
                ) : (
                    <>
                        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-[#186cb2]/10">
                            <MessageIcon size={17} color="#186cb2" />
                        </div>
                        <div className="min-w-0 flex-1">
                            <p className="truncate text-xs font-semibold text-gray-800">
                                Proposal Group Chat
                            </p>
                            <p className="truncate text-[10px] text-gray-500">
                                Collaborate with your team.
                            </p>
                        </div>
                    </>
                )}
                <div className="flex shrink-0 items-center gap-1">
                    {/* SEARCH */}
                    <button
                        type="button"
                        onClick={() => {
                            setIsSearchOpen(!isSearchOpen);
                            if (isSearchOpen) {
                                setSearchTerm('');
                            }
                        }}
                        className={`flex h-8 w-8 items-center justify-center rounded-md border transition ${
                            isSearchOpen
                                ? 'border-[#186cb2]/30 bg-[#186cb2]/10 text-[#186cb2]'
                                : 'border-gray-200 bg-white text-gray-500 hover:border-[#186cb2]/30 hover:bg-[#186cb2]/5 hover:text-[#186cb2]'
                        }`}
                        title={isSearchOpen ? 'Close search' : 'Search messages'}
                    >
                        {isSearchOpen ? (
                            <CloseIcon />
                        ) : (
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4" >
                                <circle cx="11" cy="11" r="7" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="m20 20-4-4" />
                            </svg>
                        )}
                    </button>
        
                    {/* ATTACHMENTS */}
                    <button
                        type="button"
                        onClick={() => setShowAttachments(true)}
                        className="relative flex h-8 shrink-0 items-center gap-1.5 rounded-md border border-gray-200 bg-white px-2 text-[10px] font-medium text-gray-600 transition hover:border-[#186cb2]/30 hover:bg-[#186cb2]/5 hover:text-[#186cb2]"
                        title="View all attachments"
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4" >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                            />
                        </svg>
                        <span className="hidden sm:inline">
                            Attachments
                        </span>
        
                        {allAttachments.length > 0 && (
                            <span className="flex min-w-4 items-center justify-center rounded-full bg-[#186cb2] px-1 py-0.5 text-[8px] font-bold leading-none text-white">
                                {allAttachments.length > 99 ? '99+' : allAttachments.length}
                            </span>
                        )}
                    </button>
                </div>
            </div>
        
            {/* SEARCH RESULT */}
            {isSearchOpen && searchTerm && (
                <div className="flex items-center justify-between border-t border-gray-100 px-3 py-1.5">
                    <span className="text-[9px] text-gray-400">
                        {filteredMessages.length} {filteredMessages.length === 1 ? 'message' : 'messages'} found
                    </span>
                    {allAttachments.length > 0 && (
                        <button
                            type="button"
                            onClick={() => setShowAttachments(true)}
                            className="text-[9px] font-medium text-[#186cb2] hover:underline"
                        >
                            View all attachments
                        </button>
                    )}
                </div>
            )}
        </div>
    )
}
